import { fn } from '@storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { ChipProps } from './Chip';

import { Chip } from './Chip';

const codeString = '<Chip label={string} onDelete={onDeleteFunction(label)}/>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Chip',
  component: Chip,
  argTypes: {},
  parameters: {
    inspectComponent: Chip,
    codeString: codeString,
  },
} as Meta<ChipProps>;

const Template: StoryFn<ChipProps> = (args) => <Chip {...args} />;

const defaultArgs: Partial<ChipProps> = {
  label: 'Nederlands',
  onDelete: fn(),
};

export const ChipExample = Template.bind({});
ChipExample.args = {
  ...defaultArgs,
};

export const ChipLongLabel = Template.bind({});
ChipLongLabel.args = {
  label: 'Een filter met een veel te lang label',
  onDelete: fn(),
};
